import { ApiHttpClient } from "../../common/http/api-http-client";
import { HttpRequest } from "@/core/common/http/http-request";
import { JobStatusInterface } from "@/core/common/jobs/job-status.interface";

export class JobsResource {
  resourceUrl = "/api/jobs";

  constructor(protected readonly apiHttpClient: ApiHttpClient) {}

  async getJobStatus(id: string): Promise<JobStatusInterface> {
    const url = this.resourceUrl + "/" + id + "/status";

    return await this.apiHttpClient.request<JobStatusInterface, JobStatusInterface>(
      HttpRequest.create({ url: url, auth: true })
    );
  }

  remove(id: string): Promise<void> {
    return this.apiHttpClient.request<void, void>(
      HttpRequest.create({ url: this.resourceUrl + "/" + id, auth: true, method: "DELETE", type: "text" })
    );
  }
}
